// extracted by mini-css-extract-plugin
export default {"warningBox":"LegalWarning_warningBox__GP-d1"};